import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner } from 'react-bootstrap';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import TaxiLoader from '../components/TaxiLoader';
import '../styles/PlakaListesi.css';

interface Plaka {
  Plate: string;
  Date: string;
  grup: number;
}

// PlakaData artık array olacak
// type PlakaData = { [grup: string]: Plaka[] };
type PlakaData = Plaka[][];

type TabType = 'otopark' | 'icHat' | 'disHat';

const tabOptions: { key: TabType; label: string; api: string }[] = [
  { key: 'otopark', label: 'Otopark', api: 'https://crm.havalimanitaksi.com.tr/plakasorgu.php?Sayfa=PlakaListesi&tip=giris' },
  { key: 'icHat', label: 'İç Hat', api: 'https://crm.havalimanitaksi.com.tr/plakasorgu.php?Sayfa=PlakaListesi&tip=cikis&yon=1' },
  { key: 'disHat', label: 'Dış Hat', api: 'https://crm.havalimanitaksi.com.tr/plakasorgu.php?Sayfa=PlakaListesi&tip=cikis&yon=2' },
];

const PlakaListesi: React.FC = () => {
  const [data, setData] = useState<PlakaData>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdate, setLastUpdate] = useState<string>('');
  const [currentTime, setCurrentTime] = useState<string>('');
  const [activeTab, setActiveTab] = useState<TabType>('otopark');

  // Saat güncelle
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  // Plaka verisi çek
  const fetchPlakalar = async () => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = tabOptions.find(t => t.key === activeTab)?.api || tabOptions[0].api;
      const response = await fetch(apiUrl);
      const json = await response.json();
      // JSON'dan gelen data arrayini doğrudan sakla
      setData(json.data || []);
      setLastUpdate(new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    } catch (err) {
      setError('Veri yüklenemedi. Lütfen tekrar deneyin.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPlakalar();
    const interval = setInterval(fetchPlakalar, 120000); // 2 dakika
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [activeTab]);

  const allPlates = data.flat();
  const groupCount = data.length;

  return (
    <div className="plaka-wrapper" style={{ paddingTop: 70 }}>
      <Header title="Otoparktaki Araçlar" />
      <div className="plaka-header-app">
        <div className="tab-menu">
          {tabOptions.map(tab => (
            <button
              key={tab.key}
              className={`tab-btn${activeTab === tab.key ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="istatistik-panel-app">
          <span><b>Plaka:</b> {allPlates.length}</span>
          <span><b>Grup:</b> {groupCount}</span>
          <span><b>Saat:</b> {currentTime}</span>
          <span><b>Yenileme:</b> {lastUpdate}</span>
          <button className="refresh-btn" onClick={fetchPlakalar} title="Yenile">
            <i className="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
      <main className="plaka-main">
        {loading ? (
          <TaxiLoader message="Plaka bilgileri güncelleniyor..." />
        ) : error ? (
          <div className="plaka-no-data">{error}</div>
        ) : allPlates.length === 0 ? (
          <div className="plaka-no-data">Gösterilecek veri yok.</div>
        ) : (
          <div className="plaka-grid">
            {data.map((plakalar, idx) => (
              <div className="plaka-group" key={idx}>
                <div className="plaka-group-header">
                  <i className="fas fa-layer-group"></i> <b>Grup {plakalar[0]?.grup}</b>
                </div>
                <div className="plaka-list">
                  {plakalar.map((plaka) => (
                    <div className="plaka-item" key={plaka.Plate}>
                      <span className="plaka-icon"><i className="fas fa-taxi"></i></span>
                      <span className="plaka-number">{plaka.Plate}</span>
                      <span className="plaka-time">{plaka.Date.split(' ')[1]}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <TabBar />
    </div>
  );
};

export default PlakaListesi; 